export const getUsers = state => state.user.usersList;
export const getUserDetails = state => state.user.userDetails;
